import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6.636 5.636a9 9 0 0 1 13.397 .747l-5.619 5.617l5.619 5.617a9 9 0 1 1 -13.397 -11.981","key":"svg-0"}],["path",{"d":"M11.5 7.5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0","key":"svg-1"}]]

const IconPacman = createReactComponent('outline', 'pacman', 'Pacman', __iconNode);

export default IconPacman;